<div class="search-component">
  <form [formGroup]="autoForm">
    <mat-form-field  appearance="outline" class="primary-input-outline search-box">
      <input #dataInput matInput placeholder="{{searchoptionalParams.placeholder}}" formControlName="inputText" [type]="searchoptionalParams.inputtype?searchoptionalParams.inputtype:'text'" [numbersOnly]="searchoptionalParams.inputtype == 'number'" autocomplete="off" (focusout)='callFO()' (focusin)='callFI()'>
      @if (!cancelIcon) {
        <i class="icon-search search-icons"></i>
      }
      @if (cancelIcon) {
        <i class="icon-requisition-denied  search-icons" (click)="clearText(true)"></i>
      }
    </mat-form-field>
  </form>
</div>
